













































































import "vue-loading-overlay/dist/vue-loading.css";
import "flatpickr/dist/flatpickr.css";
// import store from "@/store";
// import defineAbilityFor from "./services/ability";
import { Component, Watch } from "vue-property-decorator";
import QScripts from "@/common/qScripts.vue";
import click2Top from "@/common/directives/click2Top";

import generateCdnCookie from "@/common/mixins/generateCdnCookie";
import { mixins } from "vue-class-component";

@Component({
  name: "QAdmin",
  components: {
    QScripts,
  },
  directives: {
    click2Top,
  },
})
export default class QAdmin extends mixins(generateCdnCookie) {
  public isShow = false;

  public isChangeRoute = 1;

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newValue: any, oldValue: any) {
    if (newValue && oldValue && newValue.name !== oldValue.name) {
      this.isChangeRoute++;
    }
    // this.checkRole();
  }

  async mounted() {
    this.$nextTick(() => {
      this.loadScript();
      this.resetCookie();
    });
  }

  getHackReload() {
    this.isChangeRoute;
    this.loadScript();
    return this.isChangeRoute;
  }

  loadScript() {
    (this.$refs.script as QScripts).muuqBase();
  }
}
